import { LinkType, Product, Category } from 'src/common/explorer/lib/types';

export function buildProductUrl(
  product: Product,
  linkType: string | undefined,
  localeCode: string,
): string {
  const url = linkType === LinkType.pricing ? product.pricingUrl : product.url;

  if (url) {
    if (url.startsWith('https://')) {
      return url;
    } else {
      if (localeCode !== 'us-en') {
        return `https://www.ibm.com/${localeCode}${url}`;
      } else {
        return `https://www.ibm.com${url}`;
      }
    }
  }

  return '';
}

export function buildCategoryUrl(
  category: Category,
  localeCode: string,
): string {
  const url = category.link || '';

  if (urlIsRelative(url) && urlShouldBeLocalized(localeCode)) {
    if (category.localeWhitelist?.indexOf(localeCode) !== -1) {
      return `/${localeCode}${url}`;
    } else {
      return url;
    }
  } else {
    return url;
  }
}

function urlIsRelative(url: string): boolean {
  return url?.charAt(0) === '/' ? true : false;
}

export function urlShouldBeLocalized(localeCode: string): boolean {
  const pieces = localeCode.split('-');

  return !pieces.includes('us');
}

export function swapCountryAndLanguage(localeCode: string): string {
  // IBM's Drupal changes the url prefix to be `country-language`,
  // so we need to adapt the provided langcode.
  let swappedLocaleCode = localeCode;

  if (localeCode.indexOf('-') > -1) {
    swappedLocaleCode = `${localeCode.split('-')[1]}-${
      localeCode.split('-')[0]
    }`;
  }

  return swappedLocaleCode;
}
